import React from "react";
import * as Axios from "axios";
import { withAuthentication } from "@coverme/identity";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { MyCasesContainer } from "./containers/MyCasesContainer";
import { ShellContainer } from "./containers/ShellContainer";
import { withRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { ToastContainer } from "react-toastify";
import { CustomerSelectionContainer } from "./containers/CustomerSelectionContainer";
import DocumentRepositoryContainer from "./containers/DocumentRepositoryContainer";
import { EncounterComponent } from "./components/EncounterComponent";
import { AddNewCaseContainer } from "./containers/AddNewCaseContainer";
import { RetrocheckContainer } from "./containers/Retrocheck/RetrocheckContainer";
import { RetrocheckBillingContainer } from "./containers/RetrocheckBilling/RetrocheckBillingContainer";
import { RetrocheckFacesheetContainer } from "./containers/Retrocheck/RetrocheckFacesheetContainer";
import { RetrocheckFileInfoContainer } from "./containers/Retrocheck/RetrocheckFileInfoContainer";
import { AddInterviewWizardContainer, EditInterviewWizardContainer } from "./containers/InterviewWizardContainer";
import { ChangePasswordContainer } from "./containers/ChangePasswordContainer";
import { ReportingContainer } from "./containers/Reporting/ReportingContainer";
import { CovermeReportingContainer } from "./containers/Reporting/CovermeReportingContainer";
import ScrollToTop from "./utils/scrollToTop";

function setAuthorizationHeader(accessToken) {
    Axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
}

export const CustomerManagementRouter = ({ config }) => {
    const AuthenticatedShell = withRouter(
        withAuthentication(
            config.identity.authority,
            config.identity.clientId,
            config.identity.scope,
            config.identity.response_type,
            config.identity.redirectUrl,
            config.identity.post_logout_redirect_uri,
            config.identity.silent_redirect_uri,
            config.identity.automaticSilentRenew,
            config.identity.accessTokenExpiringNotificationTime,
            setAuthorizationHeader
        )(ShellContainer)
    );
    return (
        <>
            <Router>
                <AuthenticatedShell
                    headerType="developer"
                    includeSideNav={false}
                    isAppcuesEnabled={!!config.isAppcuesEnabled}
                    isIntercomEnabled={!!config.isIntercomEnabled}
                    isUpscopeEnabled={!!config.isUpscopeEnabled}
                    isLogRocketEnabled={!!config.isLogRocketEnabled}
                    intercomAppId={config.intercomAppId}
                >
                    <ErrorBoundary>
                        <ScrollToTop>
                            <Switch>
                                <Route path="/cases" exact component={MyCasesContainer} />
                                <Route path="/documents" exact component={DocumentRepositoryContainer} />
                                <Route path="/interview/new/person" exact component={AddNewCaseContainer} />
                                <Route path="/interview/new" component={AddInterviewWizardContainer} />
                                <Route
                                    path="/interview/:encounterId"
                                    render={props => <EncounterComponent {...props} config={config} />}
                                />
                                <Route path="/" exact component={MyCasesContainer} />
                                <Route path="/customerselection" exact component={CustomerSelectionContainer} />
                                <Route path="/reports" exact component={ReportingContainer} />
                                <Route path="/covermereports" exact component={CovermeReportingContainer} />
                                <Route path="/retrocheck" exact component={RetrocheckContainer} />
                                <Route path="/retrocheckbilling" exact component={RetrocheckBillingContainer} />
                                <Route
                                    path="/retrocheck/facesheet/:fileId/:rowNumber"
                                    render={props => <RetrocheckFacesheetContainer {...props} config={config} />}
                                />
                                <Route
                                    path="/retrocheck/file/fileInfo/:fileId"
                                    render={props => <RetrocheckFileInfoContainer {...props} config={config} />}
                                />
                                <Route path="/changepassword" exact component={ChangePasswordContainer} />
                            </Switch>
                        </ScrollToTop>
                    </ErrorBoundary>
                    <ToastContainer style={{ fontSize: "1.2rem" }} />
                </AuthenticatedShell>
            </Router>
        </>
    );
};
